import moment from "moment";
import BaseEntity from "./BaseEntity";

class EnrichedBaseEntity extends BaseEntity {
  _created = moment();
  _createdBy = undefined;
  _modified = moment();
  _modifiedBy = undefined;

  // Cached results of readableCreated/readableModified. The format depends
  // on "today", so a page left open past midnight shows the short form
  // until the next fetchAllData rebuilds the models (login, or after a
  // create/update/delete). If a setter is ever added for _created or
  // _modified, it must clear the matching cache field below.
  _readableCreated = undefined;
  _readableModified = undefined;

  constructor(enrichedJson = undefined) {
    super(enrichedJson);

    if (enrichedJson != undefined) {
      this._created = moment(enrichedJson.created);
      this._createdBy = enrichedJson.createdBy;
      this._modified = moment(enrichedJson.modified);
      this._modifiedBy = enrichedJson.modifiedBy;
    }
  }

  // Getters

  get created() {
    return this._created;
  }
  get createdBy() {
    return this._createdBy;
  }
  get modified() {
    return this._modified;
  }
  get modifiedBy() {
    return this._modifiedBy;
  }

  // Public methods

  /**
   * Converts the last modified date into a human readable date.
   * @public
   * @returns {String} - Formatted string date.
   */
  readableModified() {
    if (this._readableModified == undefined) {
      const today = moment();

      this._readableModified = this._modified.format(
        this._modified.isBefore(today, "day")
          ? EnrichedBaseEntity.VUE.$t("tzLocale")
          : "HH:mm"
      );
    }

    return this._readableModified;
  }

  /**
   * Converts the created date into a human readable date.
   * @public
   * @returns {String} - Formatted string date.
   */
  readableCreated() {
    if (this._readableCreated == undefined) {
      const today = moment();

      this._readableCreated = this._created.format(
        this._created.isBefore(today, "day")
          ? EnrichedBaseEntity.VUE.$t("tzLocale")
          : "HH:mm"
      );
    }

    return this._readableCreated;
  }
}

export default EnrichedBaseEntity;
